import { Model } from "./model";
import { Contract } from "./contract";
import { Sim } from "./sim";
import { BoxInterface } from "./box-interface";
import { BoxEvent } from "./box-event";
import { BoxCertificate } from "./box-certificate";
import { Researcher } from "./researcher";
import { BoxLocation } from "./box-location";

export class Box extends Model {

  enabled?: boolean;

  hardwareVersion?: string;

  identifier?: string;

  softwareVersion?: string;

  status?: string;

  currentTestbedIdentifier?: string;

  contract?: Contract;

  researchers?: Researcher[];

  currentCertificate?: BoxCertificate;

  boxCertificates?: BoxCertificate[];

  sim?: Sim;

  boxInterfaces?: BoxInterface[];

  boxEvents?: BoxEvent[];

  boxLocation?: BoxLocation;

  weseth2?: boolean;

  isOnline?:boolean;
}
